import API_URL from "../config";
import axios from "axios";

// import { socket } from "./../socket";
import { getCookie } from "./../utils/cookies";

export const signIn = async (email, password) => {
  try {
    const userObject = {
      email: email,
      password: password,
    };

    const res = await axios.post(`${API_URL}/api/V2/superAdmin/signIn`, userObject);

    // socket.emit("user_login", {
    //     user_id: res.data.userInfo._id
    // });

    return res.data;
  } catch (err) {
    // socket.emit("get_online_users");
    throw err;
  }
};

export const isAuthenticatedApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`${API_URL}/api/V2/superAdmin/profile/${id}/${iv}`, option);

    if (res.data) return true;
  } catch (err) {
    return false;
  }
};

export const signOut = async () => {
  try {
    const id = localStorage.getItem("id");
    // socket.emit("logOut", id);
  } catch (err) {
    throw err;
  }
};

//producer
export const getAllProducersApi = async (
  name = "",
  email = "",
  pseudo = "",
  type = "",
  status = "Tous",
  page = 1,
  limit = 10
) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const queryParams = new URLSearchParams();

    if (name) {
      queryParams.append("name", name);
    }
    if (email) {
      queryParams.append("email", email);
    }
    if (pseudo) {
      queryParams.append("pseudo", pseudo);
    }
    if (type) {
      queryParams.append("type", type);
    }

    if (status !== "Tous") {
      queryParams.append("status", status);
    }

    queryParams.append("page", page);
    queryParams.append("limit", limit);
    const url = `${API_URL}/api/V2/superAdmin/all/${id}/${iv}?${queryParams.toString()}`;

    console.log("Fetching Producers with URL:", url);

    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    console.error("API Error fetching all producers:", err.response?.data?.error || err.message);
    throw err;
  }
};

export const getOneProducerApi = async (producerId) => {
  try {
    if (!producerId) {
      throw new Error("Identifiant du produit introuvable.");
    }

    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let url = `${API_URL}/api/V2/superAdmin/getOne/${id}/${iv}/${producerId}`;

    const res = await axios.get(url, option);

    return res.data;
  } catch (err) {
    console.error(`Error fetching producer with ID ${producerId}:`, err);
    throw err;
  }
};

export const updateProducerApi = async (
  producerId,
  updatedFormData,
  isLimitedTickets,
  isLimitedInvitations,
  allowedEvents = []
) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const requestData = {
      type: updatedFormData?.type ?? "",
      firstName: updatedFormData?.firstName ?? "",
      lastName: updatedFormData?.lastName ?? "",
      email: updatedFormData?.email ?? "",
      cin: updatedFormData?.cin ?? "",
      companyName: updatedFormData?.companyName ?? "",
      ice: updatedFormData?.ice ?? "",
      if: updatedFormData?.if ?? "",
      bankAccount: updatedFormData?.bankAccount ?? "",
      pseudo: updatedFormData?.pseudo ?? "",
      password: updatedFormData?.password ?? "",
      confirmPass: updatedFormData?.confirmPass ?? "",
      isActive: updatedFormData?.isActive ?? "false",

      numberOfTickets: {
        isSelected: isLimitedTickets,
        numberOf: updatedFormData?.numberOfTickets ?? 0,
      },
      numberOfInvitations: {
        isSelected: isLimitedInvitations,
        numberOf: updatedFormData?.numberOfInvitations ?? 0,
      },
      allowedEvents,
    };
    if (updatedFormData?.password && updatedFormData?.confirmPass) {
      requestData.password = updatedFormData.password;
      requestData.confirmPass = updatedFormData.confirmPass;
    }

    let url = `${API_URL}/api/V2/superAdmin/updateSignUp/${id}/${iv}/${producerId}`;

    const res = await axios.put(url, requestData, option);

    return res.data;
  } catch (err) {
    console.error(
      `Error updating producer with ID ${producerId}:`,
      err.response?.data || err.message
    );
    throw err;
  }
};

export const deleteProducerApi = async (producerId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    let url = `${API_URL}/api/V2/superAdmin/delete/${id}/${iv}/${producerId}`;
    const res = await axios.delete(url, option);

    return res.data;
  } catch (err) {
    console.error(
      `Error deleting producer with ID ${producerId}:`,
      err.response?.data || err.message
    );
    throw err;
  }
};

export const getAllRevendeursApi = async (
  name = "",
  email = "",
  phone = "",
  pseudo = "",
  page = 1,
  limit = 10
) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const queryParams = new URLSearchParams();

    if (name) {
      queryParams.append("name", name);
    }
    if (email) {
      queryParams.append("email", email);
    }
    if (phone) {
      queryParams.append("phone", phone);
    }
    if (pseudo) {
      queryParams.append("pseudo", pseudo);
    }

    queryParams.append("page", page);
    queryParams.append("limit", limit);

    const url = `${API_URL}/api/V2/superAdmin/revendeur/all/${id}/${iv}?${queryParams.toString()}`;

    console.log("Fetching Revendeurs with URL:", url);

    const res = await axios.get(url, option);
    return res.data;
  } catch (err) {
    console.error("API Error fetching all revendeurs:", err.response?.data?.error || err.message);
    throw err;
  }
};

export const getOneRevendeurApi = async (revendeurId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/superAdmin/revendeur/getOne/${id}/${iv}/${revendeurId}`;
    const res = await axios.get(url, option);
    return res.data;
  } catch (err) {
    console.error("API Error fetching one revendeur:", err.response?.data?.error || err.message);
    throw err;
  }
};

export const updateRevendeurApi = async (revendeurId, updatedRevendeurData) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/superAdmin/revendeur/updateSignUp/${id}/${iv}/${revendeurId}`;
    const res = await axios.put(url, updatedRevendeurData, option);
    return res.data;
  } catch (err) {
    console.error("API Error updating revendeur:", err.response?.data?.error || err.message);
    throw err;
  }
};

export const deleteRevendeurApi = async (revendeurId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/superAdmin/revendeur/delete/${id}/${iv}/${revendeurId}`;
    const res = await axios.delete(url, option);
    return res.data;
  } catch (err) {
    console.error("API Error deleting revendeur:", err.response?.data?.error || err.message);
    throw err;
  }
};

export const toggleProducerStatusApi = async (producerId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const url = `${API_URL}/api/V2/superAdmin/producer/status/${id}/${iv}/${producerId}`;

    const res = await axios.patch(url, {}, option);
    return res.data;
  } catch (err) {
    console.error(
      `Error toggling status for producer ${producerId}:`,
      err.response?.data || err.message
    );
    throw err;
  }
};
